import React, { useEffect, useState, useRef } from 'react';
import { Form } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import { validateCpfCnpj } from './utils';

const DocumentInput = ({
  label,
  name,
  register,
  errors,
  isActive,
  placeholder = 'Digite o CPF ou CNPJ',
  value = ''
}) => {
  const [mask, setMask] = useState('');
  const [key, setKey] = useState(0);
  const isKeySet = useRef(false);

  useEffect(() => {
    const numericValue = value.replace(/\D/g, '');
    setMask(numericValue.length > 11 ? '99.999.999/9999-99' : '999.999.999-99');

    if (!isKeySet.current && value !== '') {
      setKey((prevKey) => prevKey + 1);
      isKeySet.current = true;
    }
  }, [value]);

  const handleKeyDown = (e) => {
    const digit = e.key.replace(/\D/g, '');
    const currentValue = e.target.value.replace(/\D/g, '');
    const size = currentValue.concat(digit).length;
    setMask(size <= 11 ? '999.999.999-99' : '99.999.999/9999-99');
  };

  return (
    <Form.Group controlId={name} className="mb-3">
      {label && <Form.Label className="mb-1">{label}</Form.Label>}

      <InputMask
        key={key}
        mask={mask}
        maskChar={null}
        placeholder={placeholder}
        defaultValue={value}
        onKeyDown={handleKeyDown}
        autoComplete="off"
        {...register(name, {
          validate: (value) => {
            const numericValue = value.replace(/\D/g, '');
        
            if (numericValue.length === 0) {
              if (!isActive) return true;
              return 'Documento é obrigatório.';
            }
        
            if (!validateCpfCnpj(value)) return 'Documento inválido.';
        
            return true;
          },
        })}        
      >
        {(inputProps) => (
          <Form.Control
            {...inputProps}
            className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
          />
        )}
      </InputMask>

      {errors[name] && (
        <Form.Control.Feedback type="invalid">
          {errors[name].message}
        </Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

export default DocumentInput;